<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero"> close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Dasher Summary</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
      ></v-text-field>
      <v-spacer></v-spacer>
    </v-toolbar>
    <div v-if="isLoaded">
      <v-data-table
        :headers="headers"
        :items="indexData.dasherSummary"
        :search="search"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td class="text-xs-center">{{ props.item.user_id }}</td>
          <td class="text-xs-center">
            {{ props.item.first_name }} {{ props.item.middle_name }}
            {{ props.item.last_name }}
          </td>
          <td class="text-xs-center">{{ props.item.created_at }}</td>
          <td class="text-xs-center" v-if="props.item.active == 1">Active</td>
          <td class="text-xs-center" v-else>In-Active</td>
          <td class="text-xs-center">{{ props.item.email }}</td>
          <td class="text-xs-center">{{ props.item.phone }}</td>
          <td class="text-xs-center">{{ props.item.nid_number }}</td>
          <td class="text-xs-center" v-if="props.item.nid_status_id == 2">
            Yes
          </td>
          <td class="text-xs-center" v-else>No</td>
          <td class="text-xs-center">{{ props.item.dob }}</td>
          <td class="text-xs-center">{{ props.item.gender_name }}</td>
          <td class="text-xs-center">{{ props.item.area }}</td>
          <td class="text-xs-center">{{ props.item.division_english }}</td>
          <td class="text-xs-center">{{ props.item.district_english }}</td>
          <td class="text-xs-center">{{ props.item.occupation_name }}</td>
          <td class="text-xs-center">{{ props.item.marital_status_name }}</td>
          <td class="text-xs-center">{{ props.item.TotalEarnedCoins }}</td>
          <td class="text-xs-center">{{ props.item.TotalRedeem }}</td>
          <td class="text-xs-center">{{ props.item.total_coin }}</td>
          <td class="text-xs-center">{{ props.item.TotalEarnedPoints }}</td>
          <td class="text-xs-center">{{ props.item.rank_id }}</td>

          <td class="justify-center layout px-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItemDasherDetail(props.item.user_id)"
                >
                  visibility
                </v-icon>
              </template>
              <span>View Details</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItemCashOutDetails(props.item.user_id)"
                >
                  paid
                </v-icon>
              </template>
              <span>View cash out details</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItemRank(props.item.user_id)"
                >
                  history_edu
                </v-icon>
              </template>
              <span>View rank details</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    search: "",
    apiUrl: "dasher-summary-report",
    headers: [
      { text: "Dasher ID", align: "center", value: "user_id" },
      { text: "Dasher Name", align: "center", value: "first_name" },
      {
        text: "Dasher Profile created date",
        align: "center",
        value: "created_at",
      },
      { text: "Dasher Profile status", align: "center", value: "active" },
      { text: "Dasher Email", align: "center", value: "email" },
      { text: "Dasher Phone No", align: "center", value: "phone" },
      { text: "NID No", align: "center", value: "nid_number" },
      { text: "NID Verified", align: "center", value: "nid_status_id" },
      { text: "DOB", align: "center", value: "dob" },
      { text: "Sex", align: "center", value: "gender_name" },
      { text: "Area", align: "center", value: "area" },
      { text: "Division", align: "center", value: "division_english" },
      { text: "District", align: "center", value: "district_english" },
      { text: "Occupation", align: "center", value: "occupation_name" },
      { text: "Marital Status", align: "center", value: "marital_status_name" },
      {
        text: "Dasher Coins Earned",
        align: "center",
        value: "TotalEarnedCoins",
      },
      { text: "Dashers Coins Redeemed", align: "center", value: "TotalRedeem" },
      { text: "Dashers Coins Balance", align: "center", value: "total_coin" },
      {
        text: "Dasher Points Earned",
        align: "center",
        value: "TotalEarnedPoints",
      },
      { text: "Dashers Rank", align: "center", value: "rank_id" },

      { text: "Actions", align: "center", value: "actions" },
    ],
    editedIndex: -1,
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
      "userImage",
      "docImage",
    ]),
    isLoaded() {
      if (this.indexData.dasherSummary) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.$store.dispatch("setIndexData", [this.apiUrl]);
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    checkItemDasherDetail(user_id) {
      this.$store.dispatch("getDasherReportDetails", [
        user_id,
        "dasher-details-report",
        "/dasher-summary-report",
        "/dasher-details-report",
      ]);
      // console.log(user_id);
    },
      checkItemCashOutDetails (user_id) {
        this.$store.dispatch('getDasherReportDetails',[user_id, 'dasher-cash-out-report','/dasher-summary-report','/dasher-cash-out-report'])
        // console.log(user_id);
      },
      checkItemRank (user_id) {
        this.$store.dispatch('getDasherReportDetails',[user_id, 'dasher-rank-details-report','/dasher-summary-report','/dasher-rank-details-report'])
        // console.log(user_id);
      },
  },
};
</script>